(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  /* --------------------------------------------------------------------------
     TIROIR DE NAVIGATION — nœuds Figma 117:7043, 117:6817 et 117:6856.

     Composant natif, comme le reste de Dawn : aucune dépendance, aucun build.
     Il remplace `header-drawer` / `menu-drawer` de Dawn, qui empilait des
     `<details>` imbriqués — un gabarit incompatible avec le va-et-vient entre
     deux niveaux de la maquette.

     Le moteur de recherche prédictive n'est PAS touché : le tiroir contient
     une instance de `predictive-search`, qui continue de fonctionner seule.
     ----------------------------------------------------------------------- */
  class ChNavDrawer extends HTMLElement {
    connectedCallback() {
      this.bouton = this.querySelector('[data-ch-nav-toggle]');
      this.panneau = this.querySelector('[data-ch-nav-panel]');
      this.voile = this.querySelector('[data-ch-nav-overlay]');
      if (!this.bouton || !this.panneau) return;

      this.surTouche = this.surTouche.bind(this);

      this.bouton.addEventListener('click', () => this.ouvrir());
      this.addEventListener('click', this.surClic.bind(this));
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.surTouche);
      document.body.classList.remove('ch-nav-lock');
    }

    surClic(evenement) {
      const cible = evenement.target;
      if (!(cible instanceof Element)) return;

      if (cible.closest('[data-ch-nav-overlay]') || cible.closest('[data-ch-nav-close]')) {
        this.fermer();
        return;
      }

      // Le retour est testé AVANT l'ouverture : le bouton « Retour » vit à
      // l'intérieur du panneau, et le panneau porte lui aussi
      // `data-ch-nav-open` (voir plus bas). Dans l'ordre inverse, la branche
      // du retour n'était jamais atteinte et le bouton restait mort.
      if (cible.closest('[data-ch-nav-back]')) {
        this.afficherVue('racine');
        return;
      }

      // ⚠️ `:not([data-ch-nav-panel])` est INDISPENSABLE.
      //
      // `data-ch-nav-open` sert à DEUX choses : sur un déclencheur il porte le
      // nom de la vue à ouvrir ; sur le panneau, `ouvrir()` le pose À VALEUR
      // VIDE comme simple drapeau d'état, et le CSS s'en sert pour la
      // translation d'entrée.
      //
      // Sans cette exclusion, `closest()` remontait jusqu'au panneau pour
      // N'IMPORTE QUEL clic à l'intérieur du tiroir, et appelait
      // `afficherVue('')`. Aucune vue ne s'appelant « », toutes étaient
      // masquées : mesuré, on passait de 10 commandes visibles à 1: il ne
      // restait que la croix et le mot MENU. Cliquer le titre, le champ de
      // recherche ou « Annuler » suffisait à vider la navigation.
      //
      // On exige en plus une valeur non vide, ceinture et bretelles.
      const ouvrant = cible.closest('[data-ch-nav-open]:not([data-ch-nav-panel])');
      const vue = ouvrant && ouvrant.getAttribute('data-ch-nav-open');
      if (vue) {
        this.afficherVue(vue);
      }
    }

    ouvrir() {
      this.afficherVue('racine', false);
      this.panneau.setAttribute('data-ch-nav-open', '');
      this.bouton.setAttribute('aria-expanded', 'true');
      if (this.voile) this.voile.hidden = false;
      document.body.classList.add('ch-nav-lock');
      document.addEventListener('keydown', this.surTouche);
      // Le panneau part de `visibility: hidden` : il n'est focalisable qu'une
      // fois sa transition de visibilité entamée. Un `focus()` synchrone ne fait
      // donc rien du tout, et le focus restait sur le burger — l'ouverture du
      // dialogue n'était jamais annoncée. Le nombre de trames à attendre n'est
      // pas fiable : mesuré, il varie d'une ouverture à l'autre. On réessaie
      // donc jusqu'à ce que le focus prenne, sur un budget borné.
      const cible = this.panneau.querySelector('[data-ch-nav-close]');
      if (cible) {
        let trames = 12;
        const poserLeFocus = () => {
          cible.focus();
          if (document.activeElement !== cible && trames-- > 0) requestAnimationFrame(poserLeFocus);
        };
        requestAnimationFrame(poserLeFocus);
      }
    }

    fermer() {
      this.panneau.removeAttribute('data-ch-nav-open');
      this.bouton.setAttribute('aria-expanded', 'false');
      if (this.voile) this.voile.hidden = true;
      document.body.classList.remove('ch-nav-lock');
      document.removeEventListener('keydown', this.surTouche);
      // Le focus revient sur le burger : sans ça il retomberait en haut du
      // document et la personne perdrait sa place.
      this.bouton.focus();
    }

    afficherVue(nom, deplacerLeFocus = true) {
      this.querySelectorAll('[data-ch-nav-view]').forEach((vue) => {
        vue.hidden = vue.getAttribute('data-ch-nav-view') !== nom;
      });

      // Même exclusion qu'au-dessus : une fois ouvert, le panneau porte lui
      // aussi `data-ch-nav-open`. Sans le filtre, il recevait un
      // `aria-expanded` — un attribut qui n'a aucun sens sur un dialogue et
      // que les lecteurs d'écran annoncent à tort.
      this.querySelectorAll('[data-ch-nav-open]:not([data-ch-nav-panel])').forEach((declencheur) => {
        declencheur.setAttribute('aria-expanded', declencheur.getAttribute('data-ch-nav-open') === nom);
      });

      // La zone défilante garde sa position d'un niveau à l'autre : on la
      // ramène en haut, sinon le titre du rayon s'ouvre hors de vue.
      this.querySelector('.ch-nav__scroll')?.scrollTo({ top: 0 });

      if (!deplacerLeFocus) return;
      const vue = this.querySelector(`[data-ch-nav-view="${nom}"]`);
      vue?.querySelector('[data-ch-nav-back], a[href], button')?.focus();
    }

    elementsFocusables() {
      const selecteur = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
      return Array.from(this.panneau.querySelectorAll(selecteur)).filter((element) => element.offsetParent !== null);
    }

    surTouche(evenement) {
      if (evenement.key === 'Escape') {
        // Quand des suggestions sont ouvertes, `Échap` les ferme d'abord :
        // c'est `predictive-search` qui s'en charge, on ne referme pas le
        // tiroir sous les doigts de la personne.
        if (this.querySelector('predictive-search[open]')) return;
        this.fermer();
        return;
      }

      if (evenement.key !== 'Tab') return;

      const liste = this.elementsFocusables();
      if (liste.length === 0) return;

      const premier = liste[0];
      const dernier = liste[liste.length - 1];

      if (!this.panneau.contains(document.activeElement)) {
        evenement.preventDefault();
        premier.focus();
      } else if (evenement.shiftKey && document.activeElement === premier) {
        evenement.preventDefault();
        dernier.focus();
      } else if (!evenement.shiftKey && document.activeElement === dernier) {
        evenement.preventDefault();
        premier.focus();
      }
    }
  }

  customElements.define('ch-nav-drawer', ChNavDrawer);

  } catch(e) { console.error(e); }
})();
})();
